import { useState } from 'react';
import Avatar from '../Avatar';
import Popover from '@mui/material/Popover';
import AccountSettings from '../../AccountSettings/AccountSettings';

const AvatarPopover = ({
  username,
  email,
  imageUrl,
  orgs,
  provider,
  onOrgSelected,
  onLogoutClick,
}) => {
  const [accountSettingsAnchorEl, setAccountSettingsAnchorEl] = useState(null);

  const handleAccountSettingsOpen = event => {
    setAccountSettingsAnchorEl(event.currentTarget);
  };

  const handleAccountSettingsClose = () => {
    setAccountSettingsAnchorEl(null);
  };

  const accountSettingsOpen = Boolean(accountSettingsAnchorEl);
  const accountSettingsId = open ? 'account-settings-popover' : undefined;
  return (
    <div data-testid='linui-avatar'>
      <Avatar
        username={username}
        imageUrl={imageUrl}
        onAvatarClick={handleAccountSettingsOpen}
      />
      <Popover
        id={accountSettingsId}
        open={accountSettingsOpen}
        anchorEl={accountSettingsAnchorEl}
        onClose={handleAccountSettingsClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <AccountSettings
          username={username}
          email={email}
          imageUrl={imageUrl}
          orgs={orgs}
          provider={provider}
          onOrgSelected={props => {
            handleAccountSettingsClose();
            onOrgSelected(props);
          }}
          onLogoutClick={props => {
            handleAccountSettingsClose();
            onLogoutClick(props);
          }}
        />
      </Popover>
    </div>
  );
};

export default AvatarPopover;
